module.exports = __webpack_public_path__ + "fc23e7b9647bc99553b81ed54fe6855c.png";